import { toast } from 'sonner'
import type { ReportErrorParams } from '@/types'

/**
 * Simple error utility that integrates with existing toast system.
 */
export const reportError = ({
  error,
  context,
  customMessage,
}: ReportErrorParams): void => {
  const message =
    error instanceof Error ? error.message : 'An unexpected error occurred'
  const displayMessage = customMessage || message

  toast.error(displayMessage)

  if (import.meta.env.DEV) {
    console.error(`[${context || 'App'}]`, error)
  }
}
